import { Link, Typography } from "@mui/material";
import type { CustomColumn } from "../..";
import type { DataTableHeaderProps } from "./Header";
import history from "helpers/history";

const RenderCell = ({
  item,
  column,
  params,
  disabled,
  customColumns,
  isNumeric = false,
}: {
  item: Record<string, any>;
  column: string;
  params: any;
  disabled?: boolean;
  customColumns: Record<string, CustomColumn>;
  isNumeric?: boolean;
}) => {
  const headerProps: DataTableHeaderProps<typeof item> =
    customColumns?.[column]?.headerProps;
  const onCLickFn = customColumns?.[column]?.headerProps?.onClick;
  
  // If a custom render cell function is provided, use it
  if (customColumns?.[column]?.renderCell) {
    return customColumns[column]?.renderCell({
      ...params,
      disabled,
    });
  }
  
  // Apply valueFormatter if available
  let displayValue = item[column];
  if (customColumns?.[column]?.valueFormatter && displayValue !== undefined) {
    displayValue = customColumns[column].valueFormatter(displayValue);
  }
  
  // Render as link if link is provided and not disabled
  if (customColumns?.[column]?.link && !customColumns?.[column]?.disableClick) {
    return (
      <Link
        sx={{
          overflow: "hidden",
          maxWidth: "95%",
          textOverflow: "ellipsis",
          alignItems: "top",
          display: "flex",
          ...headerProps?.sx,
        }}
        href={customColumns?.[column]?.link?.href(item)}
        target={customColumns?.[column]?.link?.target ?? "_blank"}
        onClick={(e) => {
          e.preventDefault(); // prevent default anchor based routing
          e.stopPropagation();
          const link = customColumns?.[column]?.link?.href(item) 
          if (link !== undefined && link !== null) {
            history.push(link)
          }
        }}
      >
        {displayValue}
      </Link>
    );
  }

  // Normal cell rendering
  return (
    <Typography
      sx={{
        overflow: "hidden",
        maxWidth: "100%",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
        wordBreak: "break-word",
        textAlign: "left",
        width: "100%",
        display: "block",
        padding: "4px 4px",
        margin: "4px 0",
        minHeight: "22px",
        fontSize: "0.875rem",
        color: disabled ? "#bdbdbd" : "inherit",
        lineHeight: "1.5",
        letterSpacing: "0.01em",
        ...headerProps?.sx,
      }}
      variant="body2"
    >
      {displayValue !== undefined && displayValue !== null
        ? displayValue
        : <span style={{ color: "#bdbdbd", fontStyle: "italic" }}>—</span>}
    </Typography>
  );
};

export default RenderCell;
